var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getTestId, isValidObject } from '@airtel/air-design-system';
import Omniwidget, { sendEvent } from '@airtel/omniwidget-container';
import { useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import { getOmniWidgetInteractionActionData, layoutWrapperContainerIds } from './OmniWidgetUtils';
export var OmniWidgetComponent = props => {
  var onSubmit = props.onSubmit,
    onUserAction = props.onUserAction,
    id = props.id,
    _props$savedAddress = props.savedAddress,
    savedAddress = _props$savedAddress === void 0 ? {} : _props$savedAddress,
    style = props.style,
    testID = props.testID,
    omniWidgetProps = props.omniWidgetProps,
    analyticsData = props.analyticsData,
    _props$omniWidgetEven = props.omniWidgetEvent,
    omniWidgetEvent = _props$omniWidgetEven === void 0 ? {
      eventName: 'CtoWResetJourney',
      eventType: 'resetJourney',
      data: {}
    } : _props$omniWidgetEven,
    onWidgetInteraction = props.onWidgetInteraction,
    onModalToggle = props.onModalToggle,
    onLoadMetaData = props.onLoadMetaData,
    currentPlatform = props.currentPlatform,
    onModalCloseMetaData = props.onModalCloseMetaData,
    restProps = __rest(props, ["onSubmit", "onUserAction", "id", "savedAddress", "style", "testID", "omniWidgetProps", "analyticsData", "omniWidgetEvent", "onWidgetInteraction", "onModalToggle", "onLoadMetaData", "currentPlatform", "onModalCloseMetaData"]);
  var _useState = useState(0),
    mountCount = _useState[0],
    setMountCount = _useState[1];
  var _useState2 = useState(false),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var eventHandler = useCallback(event => {
    if ((event === null || event === void 0 ? void 0 : event.eventName) == 'WtoC_Modal_Open') {
      onModalToggle === null || onModalToggle === void 0 ? void 0 : onModalToggle({
        open: true
      });
      setIsModalOpen(true);
    }
    if ((event === null || event === void 0 ? void 0 : event.eventName) == 'WtoC_Modal_Closed') {
      onModalToggle === null || onModalToggle === void 0 ? void 0 : onModalToggle({
        open: false
      });
      setIsModalOpen(false);
      isValidObject(onModalCloseMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onModalCloseMetaData), {
        event
      }));
    }
    if ((event === null || event === void 0 ? void 0 : event.trigger) === 'Submitted' && (event === null || event === void 0 ? void 0 : event.eventName) === 'WtoC_Submitted') {
      var data = Object.assign(Object.assign({}, event === null || event === void 0 ? void 0 : event.data), event === null || event === void 0 ? void 0 : event.userData);
      onSubmit && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onSubmit), {
        data
      }));
    }
    if ((event === null || event === void 0 ? void 0 : event.eventName) === 'WtoC_PageLoaded') {
      sendEvent({
        eventName: savedAddress === null || savedAddress === void 0 ? void 0 : savedAddress.eventName,
        data: savedAddress === null || savedAddress === void 0 ? void 0 : savedAddress.data
      });
    }
    if (isValidObject(onWidgetInteraction)) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, getOmniWidgetInteractionActionData(event, onWidgetInteraction)), {
        event
      });
    }
  }, [JSON.stringify(savedAddress), JSON.stringify(onWidgetInteraction), JSON.stringify(onSubmit)]);
  useEffect(() => {
    onLoadMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onLoadMetaData), Object.assign({}, omniWidgetProps)));
    sendEvent({
      eventName: 'CtoW_DeviceType',
      eventType: 'deviceType',
      data: currentPlatform
    });
  }, []);
  useEffect(() => {
    layoutWrapperContainerIds === null || layoutWrapperContainerIds === void 0 ? void 0 : layoutWrapperContainerIds.map(item => {
      var _a;
      var element = document === null || document === void 0 ? void 0 : document.querySelector(item);
      (_a = element === null || element === void 0 ? void 0 : element.setAttribute) === null || _a === void 0 ? void 0 : _a.call(element, 'aria-hidden', isModalOpen ? 'true' : 'false');
    });
  }, [isModalOpen]);
  useEffect(() => {
    sendEvent({
      eventName: omniWidgetEvent === null || omniWidgetEvent === void 0 ? void 0 : omniWidgetEvent.eventName,
      eventType: omniWidgetEvent === null || omniWidgetEvent === void 0 ? void 0 : omniWidgetEvent.eventType,
      data: omniWidgetEvent === null || omniWidgetEvent === void 0 ? void 0 : omniWidgetEvent.data
    });
  }, [JSON.stringify(omniWidgetEvent)]);
  useEffect(() => {
    sendEvent({
      eventName: 'CtoWAnalytics',
      eventType: 'clickstreamData',
      data: analyticsData
    });
  }, [JSON.stringify(analyticsData)]);
  var sendSavedAddress = useCallback(() => {
    sendEvent(savedAddress);
  }, [JSON.stringify(savedAddress)]);
  useEffect(() => {
    sendSavedAddress();
  }, [sendSavedAddress]);
  useEffect(() => {
    setTimeout(() => {
      setMountCount(prevState => prevState + 1);
    }, 500);
  }, [JSON.stringify(onSubmit)]);
  return _jsx(View, Object.assign({}, restProps, {
    style: style
  }, getTestId(testID), {
    children: _jsx(Omniwidget, Object.assign({}, getTestId(testID), omniWidgetProps, {
      eventListener: eventHandler,
      persistStorage: false,
      mountCount: mountCount
    }))
  }));
};
OmniWidgetComponent.genericRendererKey = 'AirOmniWidget';